import apiClient from './apiClient';

export const getHintList = () => apiClient.get('/hint');
